module.exports = __webpack_public_path__ + "media/images/very_good_star-133442c6e3f458b24d318b4c5c308cb2.svg";